module.exports = __webpack_public_path__ + "static/media/dependabot_logo.9c45605e.svg";